import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionsLogin } from '../../actions';
import { ComponentsLoginForm } from "../../components/Login/Form";
import { ServiceLogin } from "../../service/Login";
import { Messages } from 'primereact/messages';
import { ServiceMessage } from "../../service/Message";
import { ComponentsAppSplash } from "../../components/App/Splash";
import { ScreensLGPDForm } from '../LGPD/Form';
import { HistoricoAceiteLGPD } from '../../service/HistoricoAceiteLGPD';
import { ServiceConfig } from './../../service/Config';

class ScreensLoginForm extends Component {

    constructor() {

        super();

        this.state = {
            splash: false,
            isLicense: false,
            objLGPD: { Usuario: '', Exibir: false, Perfil: "" }
        };

        this.aceiteLGPD = localStorage.getItem('AceiteLGPD') === 'SIM';

        this.serviceLogin = new ServiceLogin();
        this.historicoAceiteLGPD = new HistoricoAceiteLGPD();

    }

    componentDidMount() {
        if (sessionStorage.getItem('auth'))
            this.historicoAceiteLGPD.ChecarAceiteLGPD();
    }

    getDadosUsuario(data) {
        return {
            Nome: data.Nome,
            AcessoDTO: {
                UsuarioId: data.Id,
                Perfil: 'Medico',
                DadosAcesso: ''
            }
        }
    }

    getConfig(e) {
        try {

            this.serviceConfig = new ServiceConfig();
            this.serviceConfig.GetConfig()
                .then(res => {
                    try {
                        const config = {};
                        let objConfig = {};
                        res.data.map(obj => {
                            config[obj.Key] = { Value: obj.Value };
                        })
                        if (config['NOME_BOTAO_IMPRIMIR_PORTAL'] && config['NOME_BOTAO_IMPRIMIR_PORTAL'].Value) {
                            objConfig.NomeBotaoImprimirPortal = config['NOME_BOTAO_IMPRIMIR_PORTAL'].Value;
                        }

                        if (config['23']) {
                            objConfig['23'] = JSON.parse(config['23'].Value);
                        }
                        sessionStorage.setItem('config', JSON.stringify(objConfig));

                        this.serviceLogin.login(e.usuario, e.senha)
                            .then(response => {

                                const isLicense = JSON.parse(sessionStorage.getItem("config"));

                                if (this.aceiteLGPD === false)
                                    return this.setState({ objLGPD: { Usuario: this.getDadosUsuario(response), Exibir: true } });

                                if (isLicense['23']) {
                                    this.setState({ isLicense: isLicense });
                                } else {
                                    window.location = "#/portal";
                                }
                            })
                            .catch(err => {
                                ServiceMessage.warn('Usuário ou senha inválidos!');
                            })
                            .finally(() => { this.setState({ splash: false }); });
                    }
                    catch (error) {
                        console.log(error);
                    }
                })
        } catch (err) {
            console.log("erro catch", err)
        }
    }

    handleExecute(e) {

        if (e.usuario === "")
            return ServiceMessage.warn('Preencha o campo Login.');

        if (e.senha === "")
            return ServiceMessage.warn('Preencha o campo Senha.');

        this.setState({ splash: true });

        this.getConfig(e);
    }

    render() {

        return (
            <div>
                <ScreensLGPDForm objLGPD={this.state.objLGPD} />
                <ComponentsAppSplash visible={this.state.splash} />
                <Messages ref={(el) => this.messages = el} />
                <ComponentsLoginForm
                    onExecute={this.handleExecute.bind(this)}
                    exibirTipo={true}
                    isLicense={this.state.isLicense}
                    perfil=""
                ></ComponentsLoginForm>
            </div>
        );

    }
}

const mapDispatchToProps = dispatch =>
    bindActionCreators({ actionsLogin }, dispatch);

const mapStateToProps = store => ({
    login: store.stateLogin.login,
});

export default connect(mapStateToProps, mapDispatchToProps)(ScreensLoginForm);